import { leadAddressInfo } from "./lead-edit-constants"
import { GenericInfoField } from "../../../../common/components/ui/GenericInfoField"
import { useLeadDashboardContext } from "../lead-dashboard/useLeadDashboardContext"


function LeadInfo() {
  const { lead } = useLeadDashboardContext()
  const setLeadAddressInfo = leadAddressInfo(lead)

  return (
    <div className="tabs-border-line">
      <div className="">

        <section className="tabs-item-style">
        <h2 className="text-2xl font-semibold mb-4">Endereço</h2>
        <div className="grid grid-cols-3 gap-2 mb-2">
          {setLeadAddressInfo.map((info) => {
            return (<GenericInfoField id={info.id} spanSize={info.spanSize} label={info.label} value={info.value} />)
          })}
        </div>
      </section>
      </div>
    </div>
  )
}
export default LeadInfo